import React, { useState, useMemo, useCallback } from 'react';
import mapclose from 'assets/mapclose.webp';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';
import InstantStaticMap from './InstantStaticMap';

type InstanceCardMapProps = {
  item: any;
  fieldType: any;
  width?: string;
  height?: string;
};

export function InstanceCardMap({
  width = '350px',
  height = '350px',
  ...props
}: InstanceCardMapProps): JSX.Element {
  const [modalVisible, setModalVisible] = useState(false);

  const expandMap = () => {
    setModalVisible(true);
  };

  const handleCancel = useCallback(() => {
    setModalVisible(false);
  }, []);

  const closeIcon = <img src={mapclose} alt="" className="w-100% h-100%" />;

  const renderMapModal = useMemo(() => {
    return (
      <Modal
        className="instance-card-map__modal-container"
        title=""
        visible={true}
        onCancel={handleCancel}
        closeIcon={closeIcon}
      >
        <InstantStaticMap
          mapExpanded={true}
          expandMap={() => null}
          showExpand={false}
          isStatic={false}
          width={'100%'}
          height={'70vh'}
          {...props}
        />
      </Modal>
    );
  }, [props, closeIcon, handleCancel]);

  return (
    <>
      {modalVisible && renderMapModal}
      <InstantStaticMap
        isStatic
        mapExpanded={false}
        expandMap={expandMap}
        showExpand={true}
        width={width}
        height={height}
        {...props}
      />
    </>
  );
}
